// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as Scaffold from "../../bundles/Scaffold/Scaffold.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as SearchBar from "../../resources/selection-and-input/SearchBar.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as TableDatetimeCell from "../../resources/tables/TableDatetimeCell.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as StockTransferTableRowActions from "../../modules/StockTransfer/StockTransferTableRowActions.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query StockTransferListPageQuery($search: String, $filterBy: InputStockTransfersQueryFilter, $before: String, $after: String, $first: Int, $last: Int)  {\nstockTransfers(search: $search, filterBy: $filterBy, before: $before, after: $after, first: $first, last: $last)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \ncode  \ncreatedAt  \nsenderShop  {\n__typename  \nname  \n}\n\nrecipientShop  {\n__typename  \nname  \n}\n\nproducts  {\n__typename  \ntotalCount  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.stockTransfers;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    stockTransfers: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.senderShop;
        let value$3 = value$1.recipientShop;
        let value$4 = value$1.products;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            code: value$1.code,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            senderShop: {
              __typename: value$2.__typename,
              name: value$2.name
            },
            recipientShop: {
              __typename: value$3.__typename,
              name: value$3.name
            },
            products: {
              __typename: value$4.__typename,
              totalCount: value$4.totalCount
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.stockTransfers;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.products;
    let value$3 = value$2.totalCount;
    let value$4 = value$2.__typename;
    let products = {
      __typename: value$4,
      totalCount: value$3
    };
    let value$5 = value$1.recipientShop;
    let value$6 = value$5.name;
    let value$7 = value$5.__typename;
    let recipientShop = {
      __typename: value$7,
      name: value$6
    };
    let value$8 = value$1.senderShop;
    let value$9 = value$8.name;
    let value$10 = value$8.__typename;
    let senderShop = {
      __typename: value$10,
      name: value$9
    };
    let value$11 = value$1.createdAt;
    let value$12 = Scalar.Datetime.serialize(value$11);
    let value$13 = value$1.code;
    let value$14 = value$1.id;
    let value$15 = value$1.__typename;
    let node = {
      __typename: value$15,
      id: value$14,
      code: value$13,
      createdAt: value$12,
      senderShop: senderShop,
      recipientShop: recipientShop,
      products: products
    };
    let value$16 = value.__typename;
    return {
      __typename: value$16,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let stockTransfers = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    stockTransfers: stockTransfers
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInputStockTransfersQueryFilter(inp) {
  let a = inp.createdAt;
  return {
    createdAt: a !== undefined ? serializeInputObjectDateFilter(a) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.filterBy;
  let a$2 = inp.before;
  let a$3 = inp.after;
  let a$4 = inp.first;
  let a$5 = inp.last;
  return {
    search: a !== undefined ? a : undefined,
    filterBy: a$1 !== undefined ? serializeInputObjectInputStockTransfersQueryFilter(a$1) : undefined,
    before: a$2 !== undefined ? a$2 : undefined,
    after: a$3 !== undefined ? a$3 : undefined,
    first: a$4 !== undefined ? a$4 : undefined,
    last: a$5 !== undefined ? a$5 : undefined
  };
}

function makeVariables(search, filterBy, before, after, first, last) {
  return {
    search: search,
    filterBy: filterBy,
    before: before,
    after: after,
    first: first,
    last: last
  };
}

function makeInputObjectInputStockTransfersQueryFilter(createdAt, param) {
  return {
    createdAt: createdAt
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeDefaultVariables() {
  return {
    search: undefined,
    filterBy: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputStockTransfersQueryFilter: serializeInputObjectInputStockTransfersQueryFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables,
  makeInputObjectInputStockTransfersQueryFilter: makeInputObjectInputStockTransfersQueryFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputStockTransfersQueryFilter: serializeInputObjectInputStockTransfersQueryFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables,
  makeInputObjectInputStockTransfersQueryFilter: makeInputObjectInputStockTransfersQueryFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function encoder(param) {
  return Stdlib_Option.map(param.createdAtDateRange, param => [
    param[0].getTime(),
    param[1].getTime()
  ]);
}

function decoder(createdAtDateRange) {
  return {
    TAG: "Ok",
    _0: {
      createdAtDateRange: Stdlib_Option.flatMap(createdAtDateRange, range => {
        if (range.length !== 2) {
          return;
        }
        let start = range[0];
        let end = range[1];
        return [
          new Date(start),
          new Date(end)
        ];
      })
    }
  };
}

function useJsonCodec() {
  return JsonCodec.object1(encoder, decoder, JsonCodec.optional(JsonCodec.field("createdAtDateRange", JsonCodec.array(JsonCodec.float))));
}

let Filters = {
  encoder: encoder,
  decoder: decoder,
  useJsonCodec: useJsonCodec
};

let Row = {};

function makeQueryVariables(_defaultQueryVariables, connectionArguments, search, filterBy, param) {
  return {
    search: search,
    filterBy: filterBy,
    before: connectionArguments.before,
    after: connectionArguments.after,
    first: connectionArguments.first,
    last: connectionArguments.last
  };
}

function makeQueryVariablesFilterBy(param) {
  let createdAtDateRange = param.createdAtDateRange;
  return {
    createdAt: createdAtDateRange !== undefined ? ({
        _after: undefined,
        _before: undefined,
        _between: [
          Scalar.Datetime.serialize(createdAtDateRange[0]),
          Scalar.Datetime.serialize(createdAtDateRange[1])
        ]
      }) : undefined
  };
}

function totalCountFromQueryData(param) {
  return param.stockTransfers.totalCount;
}

function cursorsFromQueryData(param) {
  let stockTransfers = param.stockTransfers;
  return [
    stockTransfers.pageInfo.startCursor,
    stockTransfers.pageInfo.endCursor
  ];
}

function rowsFromQueryDataAndState(param, param$1) {
  return param.stockTransfers.edges.map(edge => ({
    id: edge.node.id,
    code: edge.node.code,
    date: edge.node.createdAt,
    senderShop: edge.node.senderShop.name,
    recipientShop: edge.node.recipientShop.name,
    productsCount: edge.node.products.totalCount
  }));
}

function keyExtractor(param) {
  return param.id;
}

let Scaffolded = Scaffold.Make({
  useFiltersJsonCodec: useJsonCodec,
  QueryInner: Query_inner,
  useQuery: use,
  makeQueryVariables: makeQueryVariables,
  makeQueryVariablesFilterBy: makeQueryVariablesFilterBy,
  cursorsFromQueryData: cursorsFromQueryData,
  totalCountFromQueryData: totalCountFromQueryData,
  rowsFromQueryDataAndState: rowsFromQueryDataAndState,
  keyExtractor: keyExtractor
});

function StockTransferListPage(props) {
  let notifier = Notifier.use(undefined, undefined);
  let initialState = Scaffolded.makeInitialState({
    createdAtDateRange: undefined
  });
  let match = Scaffolded.use(() => initialState);
  let dispatch = match[1];
  let state = match[0];
  let defaultQueryVariables = {
    search: undefined,
    filterBy: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined
  };
  let match$1 = state.filters;
  let filters = JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.createdAtDateRange,
        placeholder: I18n.t("Since the beginning"),
        onChange: createdAtDateRange => dispatch({
          TAG: "FiltersUpdated",
          _0: param => ({
            createdAtDateRange: createdAtDateRange
          })
        }),
        triggerLabelDisplay: "showPreset"
      }),
      match$1.createdAtDateRange !== undefined ? JsxRuntime.jsx(Scaffold.ResetFiltersButton.make, {
          onPress: () => dispatch({
            TAG: "FiltersUpdated",
            _0: param => initialState.filters
          })
        }) : null
    ],
    space: "small"
  });
  let actions = JsxRuntime.jsx(Button.make, {
    label: I18n.t("New stock transfer"),
    variant: "solid",
    tone: "brand",
    size: "legacy_large",
    href: props.stockTransferCreateRoute
  });
  let banner = JsxRuntime.jsx(Notifier.Banner.make, {
    notifier: notifier
  });
  let searchBar = JsxRuntime.jsx(SearchBar.make, {
    placeholder: I18n.t("Search a stock transfer"),
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let emptyState;
  let exit = 0;
  if (state.currentPage !== 1 || state.searchQuery !== undefined || state.filters.createdAtDateRange !== undefined) {
    exit = 1;
  } else {
    emptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.create,
      title: I18n.t("Welcome to the stock transfers space.")
    });
  }
  if (exit === 1) {
    emptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword/filter or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query and filters"),
        onPress: () => dispatch({
          TAG: "Reset",
          _0: initialState
        })
      })
    });
  }
  let scaffoldedColumns = [
    {
      name: I18n.t("Reference"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 120
        },
        sticky: true
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.code
      })
    },
    {
      name: I18n.t("Datetime"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 120
        }
      },
      render: param => JsxRuntime.jsx(TableDatetimeCell.make, {
        value: param.date
      })
    },
    {
      name: I18n.t("Issuing shop"),
      layout: {
        width: {
          NAME: "pct",
          VAL: 25
        }
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.senderShop
      })
    },
    {
      name: I18n.t("Recipient shop"),
      layout: {
        width: {
          NAME: "pct",
          VAL: 25
        }
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.recipientShop
      })
    },
    {
      name: I18n.t("Number of unique references"),
      layout: {
        width: {
          NAME: "px",
          VAL: 200
        }
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.productsCount
      })
    },
    {
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 65
        },
        width: {
          NAME: "px",
          VAL: 65
        }
      },
      render: param => JsxRuntime.jsx(StockTransferTableRowActions.make, {
        id: param.id,
        code: param.code,
        onError: message => notifier.add({
          TAG: "Error",
          _0: message
        }, undefined, undefined)
      })
    }
  ];
  return JsxRuntime.jsx(Scaffolded.make, {
    title: I18n.t("Stock transfers"),
    state: state,
    dispatch: dispatch,
    columns: scaffoldedColumns,
    filters: filters,
    actions: actions,
    banner: banner,
    searchBar: searchBar,
    emptyState: emptyState,
    defaultQueryVariables: defaultQueryVariables
  });
}

let make = React.memo(StockTransferListPage);

export {
  Query,
  Filters,
  Row,
  Scaffolded,
  make,
}
/* query Not a pure module */
